import {SET_ZOBJECTS} from 'constants/action-types.js';
import {SET_OBJECT_DRAGGING} from 'constants/action-types.js';
import {SET_ZOBJECT_TYPE_DRAGGING} from 'constants/action-types.js';
import {SET_ZOBJECT_BACKGROUND} from 'constants/action-types.js';
import {SET_ZOBJECT_MODAL} from 'constants/action-types.js';
import {SET_ZMESSAGES} from 'constants/action-types.js';
import {SET_VIEWABLE_SUBPATCHES} from 'constants/action-types.js';
import {SET_ZOBJECT_SIZE} from 'constants/action-types.js';
import {SET_VIEWABLE_ZOBJECTS} from 'constants/action-types.js';
import {SET_SELECTED_ZOBJECT} from 'constants/action-types.js';
import {SET_SECONDARY_ZOBJECT} from 'constants/action-types.js';
import {SET_JAKI_GRID} from 'constants/action-types.js';
import {SET_UX_LOCKED} from 'constants/action-types.js';
import {SET_FULL_SCREEN_ZOBJECT} from 'constants/action-types.js';
import {SET_OBJECT_STYLING} from 'constants/action-types.js';
import {SET_ZOBJECT_FLASHING} from 'constants/action-types.js';
import {SET_ZOBJECT_TOOLTIP} from 'constants/action-types.js';
import {SET_ZOBJECT_CONTEXT_MENU} from 'constants/action-types.js';
import {SET_ZOBJECTS_STACK} from 'constants/action-types.js';
import {SET_ZOBJECT_PROGRESSBAR} from 'constants/action-types.js';

let initialState = {
    zobjectsStack: [],
    tooltip: {},
    contextMenu: {},
    zobjectsFlashing: {},
    objectDragging: undefined,
    zobjectTypeDragging: undefined,
    zobjects: {},
    zmessages: {},
    viewableSubPatches: [],
    viewableZObjects: [],
    selectedZObject: undefined,
    jakiGrids: {},
    uxLocked: false,
    fullScreenZObject: undefined,
    objectStylings: {},
    zobjectSizes: {},
    zobjectBackground: undefined
};
    
export default (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_ZOBJECT_MODAL:
        return {
            ... state,
            modal: action.payload
        };
    case SET_ZOBJECT_PROGRESSBAR:
        return {
            ... state,
            progressbar: action.payload
        };
    case SET_ZOBJECTS_STACK:
        return {
            ... state,
            zobjectsStack: action.payload
        };
    case SET_ZOBJECT_TOOLTIP:
        let tooltip = state.tooltip;
        if (action.payload.id) {
            tooltip[action.payload.id] = action.payload;
        } else {
            tooltip = {};
        }
        return {
            ...state,
            tooltip 
        };
    case SET_ZOBJECT_CONTEXT_MENU:
        let contextMenu = state.contextMenu;
        if (action.payload.id) {
            contextMenu[action.payload.id] = action.payload;
        } else {
            contextMenu = {};
        }
        return {
            ...state,
            contextMenu
        };
    case SET_ZOBJECT_BACKGROUND:
        return {
            ... state,
            zobjectBackground: action.payload
        };
    case SET_ZOBJECT_FLASHING:
        let zobjectsFlashing = state.zobjectsFlashing;
        zobjectsFlashing[action.payload.id] = action.payload.timestamp;
        return {
            ...state,
            zobjectsFlashing
        };
    case SET_OBJECT_DRAGGING:
        return {
            ... state,
            objectDragging: action.payload
        };
    case SET_OBJECT_STYLING:
        let objectStylings = state.objectStylings;
        objectStylings[action.payload.id] = action.payload.styling;
        return{
            ... state,
            objectStylings
        };
    case SET_ZOBJECT_SIZE:
        let zobjectSizes = state.zobjectSizes;
        zobjectSizes[action.payload.id] = action.payload.size;
        return{
            ... state,
            zobjectSizes
        };
    case SET_FULL_SCREEN_ZOBJECT:
        return {
            ... state,
            fullScreenZObject: action.payload
        };
    case SET_UX_LOCKED:
        return {
            ... state,
            uxLocked: action.payload
        };
    case SET_JAKI_GRID:
        let jakiGrids = {... state.jakiGrids};
        jakiGrids[action.payload.id] = action.payload.grid;
        return {
            ... state,
            jakiGrids
        };
        
    case SET_SELECTED_ZOBJECT:
        return {
            ... state,
            selectedZObject: action.payload
        };
    case SET_SECONDARY_ZOBJECT:
        return {
            ... state,
            secondaryZObject: action.payload
        };
    case SET_ZOBJECTS:
        let objs = {... state.zobjects};
        objs[action.payload.id] = action.payload.objects;
        return {
            ... state,
            zobjects: objs
        };
    case SET_ZMESSAGES:
        let msgs = {... state.zmessages};
        msgs[action.payload.id] = action.payload.messages;
        return {
            ... state,
            zmessages: msgs
        };
    case SET_ZOBJECT_TYPE_DRAGGING:
        return {
            ... state,
            zobjectTypeDragging: action.payload
        };
    case SET_VIEWABLE_SUBPATCHES:
        return {
            ... state,
            viewableSubPatches: action.payload
        };
    case SET_VIEWABLE_ZOBJECTS:
        return {
            ... state,
            viewableZObjects: action.payload
        };
    default:
        return state;
    }
};

